/* NAAMANE productpagina: gloed achter de infokaart = eerste productfoto. */
(() => {
  const set = () => {
    const pd = document.querySelector('.product-information .product-details');
    const img = document.querySelector('.product-information media-gallery img');
    if (!pd || !img) return;
    const src = (img.getAttribute('src') || '').replace(/([?&])width=\d+/, '$1width=300');
    if (src) pd.style.setProperty('--nm-pdp-bg', 'url("' + src + '")');
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', set); else set();
})();